export default __webpack_public_path__ + "static/media/tables.c4b1b900.png";